export default __webpack_public_path__ + "static/media/request.8b97c080.png";